/**
 * search-metrics.js
 * Dev-only timing for the search pipeline.
 * Tree-shaken to a no-op in production builds.
 */

const IS_DEV = process.env.NODE_ENV !== "production";

let _indexedCount = 0;

/** Call once after building the index to record the total item count. */
export function recordIndexSize(count) {
  if (!IS_DEV) return;
  _indexedCount = count;
}

/**
 * Wrap a search operation with timing.
 * Returns the result unchanged; logs query time + result count to console.debug.
 *
 * Usage:
 *   const results = measureSearch(query, () => sortIndexed(idx, query));
 */
export function measureSearch(query, fn) {
  if (!IS_DEV) return fn();
  const t0 = performance.now();
  const result = fn();
  const ms = (performance.now() - t0).toFixed(2);
  console.debug(
    `[search] "${query}" → ${result.length} results in ${ms}ms (${_indexedCount} indexed)`
  );
  return result;
}
